import { Component, Input } from '@angular/core';
import { CaptureStatus } from 'app/core/enums/capture-status.enum';
import { AppliedReportOptions } from 'app/core/models/report.model';
import { displayCaptureStatus } from 'app/core/options/capture-status.opts';
import { keyedReasonOptions } from 'app/core/options/capture-status-reason.opts';


@Component({
    selector: 'app-report-applied-capture-status-and-reason-option',
    templateUrl: './report-applied-capture-status-and-reason-option.component.html',
    imports: []
})
export class ReportAppliedCaptureStatusAndReasonOptionComponent {
  @Input() name = 'statusAndReasons';
  @Input() label = 'Statuses';
  @Input() options: AppliedReportOptions;

  constructor() {}

  get values() {
    if (this.options && this.options[this.name]) {
      return Object.keys(this.options[this.name]).flatMap(key => {
        const reasons = this.options[this.name][key];
        const status = CaptureStatus[key];

        if (reasons && reasons.length > 0) {
          return reasons.map(reason => {
            return `${displayCaptureStatus(status)} - ${keyedReasonOptions[reason].display}`
          })
        } else {
          return `${displayCaptureStatus(status)} - ALL`
        }
      }).join(', ');
    }
  }
}